import { ApiProperty } from "@nestjs/swagger";

export class ContainerSoIdRequest {
    @ApiProperty()
    saleOrderId?: number;


    /**
     * @param saleOrderId
    */
    constructor(saleOrderId?: number){
       this.saleOrderId=saleOrderId;
    }
}